export const ops = [
  {
    text: 'Percentage of time where',
    value: 'duration',
    typeOfValue: 'filter',
    legacyKey: 'filterDuration',
  },
  {
    text: 'Count devices where',
    value: 'countDevices',
    typeOfValue: 'filter',
    legacyKey: 'countFilter',
  },
  {
    text: 'Percentage of devices where',
    value: 'countPercentDevices',
    op: 'countDevices',
    typeOfValue: 'filter',
    legacyKey: 'countFilter',
  },
  {
    text: 'Mean value of',
    value: 'mean',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Mode value of',
    value: 'mode',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Median value of',
    value: 'median',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Count of',
    value: 'count',
    typeOfValue: 'property',
  },
  {
    text: 'Sum of',
    value: 'sum',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Spread of',
    value: 'spread',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Minimum value of',
    value: 'min',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Maximum value of',
    value: 'max',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Last value of',
    value: 'last',
    typeOfValue: 'property',
  },
  {
    text: 'Count distinct values of',
    value: 'countDistinct',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
  {
    text: 'Percentage of time in each value of',
    value: 'percentOfTimeMatching',
    op: 'duration',
    typeOfValue: 'property',
    legacyKey: 'aggregateProperty',
  },
];

export const thresholdOperations = [
  { text: 'less than', value: '<' },
  { text: 'less than or equal to', value: '<=' },
  { text: 'more than', value: '>' },
  { text: 'more than or equal to', value: '>=' },
];

export const aggregateOps = [
  'mean',
  'median',
  'mode',
  'count',
  'sum',
  'spread',
  'min',
  'max',
  'countDistinct',
];

export const DisplayTypes = {
  TABULAR: 'tabular',
  SINGLE: 'single',
  GAUGE: 'gauge',
  BAR: 'bar',
  GROUPED_BAR: 'groupedBar',
  STACKED_BAR: 'stackedBar',
  LINE: 'line',
  PIE: 'pie',
  SCATTER: 'scatter',
};

export const SxsDisplayTypes = {
  ABSOLUTE: 'absolute',
  DELTA: 'delta',
  DELTA_PERCENT: 'delta-percent',
};
